import BaseAPI from './base'
/**
 * API xử lý học sinh lớp học
 */
class StudentAPI extends BaseAPI {}

export default new StudentAPI('v1/student-classrooms', 'Student')
